import Vue from "vue"
import "vue-scroll-picker/dist/style.css"
import { ScrollPicker, ScrollPickerGroup } from "vue-scroll-picker"
Vue.component('scroll-picker', ScrollPicker);
Vue.component('scroll-picker-group', ScrollPickerGroup);